import { api_host } from '../../common/globals/constants';

export async function fetchApdexConfig({ objetivoId }) {
  let token = sessionStorage.getItem('key');
  const response = await fetch(
    `${api_host}/reporte/online/indicadores/getDifferenceApdexObjConfig/?token=${token}&objetivo=${objetivoId}&start=${Date.now()}`,
  );
  if (!response.ok) {
    throw new Error('error-fetching-apdex-config');
  }
  const data = await response.json();
  return data;
}
